import * as React from "react"
import PropTypes from "prop-types"
import * as AvatarPrimitive from "@radix-ui/react-avatar"

import { cn } from "@/lib/utils"

const Avatar = React.forwardRef(({ className, ...props }, ref) => (
  <AvatarPrimitive.Root
    ref={ref}
    data-slot="avatar"
    className={cn("relative flex size-8 shrink-0 overflow-hidden rounded-full", className)}
    {...props}
  />
));
Avatar.displayName = AvatarPrimitive.Root.displayName;
Avatar.propTypes = {
  className: PropTypes.string,
};

const AvatarImage = React.forwardRef(({ className, ...props }, ref) => (
  <AvatarPrimitive.Image
    ref={ref}
    data-slot="avatar-image"
    className={cn("aspect-square size-full", className)}
    {...props}
  />
));
AvatarImage.displayName = AvatarPrimitive.Image.displayName;
AvatarImage.propTypes = {
  className: PropTypes.string,
};

const AvatarFallback = React.forwardRef(({ className, ...props }, ref) => (
  <AvatarPrimitive.Fallback
    ref={ref}
    data-slot="avatar-fallback"
    className={cn(
      "bg-muted flex size-full items-center justify-center rounded-full",
      className
    )}
    {...props}
  />
));
AvatarFallback.displayName = AvatarPrimitive.Fallback.displayName;
AvatarFallback.propTypes = {
  className: PropTypes.string,
};

const AvatarGroup = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    data-slot="avatar-group"
    className={cn("flex items-center justify-center -space-x-2", className)}
    {...props}
  />
));
AvatarGroup.displayName = "AvatarGroup";
AvatarGroup.propTypes = {
  className: PropTypes.string,
};

const AvatarOverflowIndicator = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    data-slot="avatar-overflow-indicator"
    className={cn(
      "relative flex size-8 shrink-0 items-center justify-center rounded-full bg-muted text-muted-foreground",
      className
    )}
    {...props}
  />
));
AvatarOverflowIndicator.displayName = "AvatarOverflowIndicator";
AvatarOverflowIndicator.propTypes = {
  className: PropTypes.string,
};

export { Avatar, AvatarImage, AvatarFallback, AvatarGroup, AvatarOverflowIndicator }
